import { render, staticRenderFns } from "./DashboardMobile.vue?vue&type=template&id=09e20ed9"
import script from "./DashboardMobile.vue?vue&type=script&lang=js"
export * from "./DashboardMobile.vue?vue&type=script&lang=js"
import style0 from "./DashboardMobile.vue?vue&type=style&index=0&id=09e20ed9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports